const cookieAgreements = document.querySelector('.js-cookie-agreements');
const acceptCookieName = 'cookie_agreements_accepted';
const acceptCookieMaxAge = 60 * 60 * 24 * 365;
const declineCookieName = 'cookie_agreements_declined';
const declineCookieMaxAge = 60 * 60 * 24 * 30;

if (cookieAgreements) {
  const acceptButton = cookieAgreements.querySelector('.js-cookie-agreements-accept');
  const declineButton = cookieAgreements.querySelector('.js-cookie-agreements-decline');

  if (!hasCookie(acceptCookieName) && !hasCookie(declineCookieName)) {
    cookieAgreements.hidden = false;
  }

  if (acceptButton) {
    acceptButton.addEventListener('click', () => {
      setCookie(acceptCookieName, acceptCookieMaxAge);
      cookieAgreements.hidden = true;
    });
  }

  if (declineButton) {
    declineButton.addEventListener('click', () => {
      setCookie(declineCookieName, declineCookieMaxAge);
      cookieAgreements.hidden = true;
    });
  }
}

function hasCookie(name) {
  return document.cookie.split(';').some(cookie => cookie.trim().indexOf(`${name}=`) === 0);
}

function setCookie(name, maxAge) {
  document.cookie = `${name}=1; path=/; max-age=${maxAge}; SameSite=Lax`;
}
